import { display } from "redux-react/reducers/snackBarReducer";
import { api } from "./api";

const actions = {
	/**
	 * Allow to insert a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} data the data to insert
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	insertResource: (resource, data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/resource/${resource}`,
					data,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to get a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} resourceID the data to insert
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	getResource: (resource, resourceID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/resource/${resource}/${resourceID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to update a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {string} resourceID the id of the resource
	 * @param {object} resourceUpdate the updates to bring to the resource
	 * @param {function} onSuccess the function to call on success
	 */
	updateResource: (resource, resourceID, resourceUpdate, onSuccess) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/resource/${resource}/${resourceID}`,
					data: resourceUpdate,
					onSuccess,
					onFailure: err => {
						dispatch(
							display({
								type: "error",
								message: err.response?.data?.error ?? "none"
							})
						);
					}
				})
			);
		};
	},
	/**
	 * Allow to delete a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {string} resourceID the id of the resource
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	deleteResource: (resource, resourceID, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "DELETE",
					url: `/api/v1/resource/${resource}/${resourceID}`,
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Allow to update a resource on the backend
	 * @param {string} resource the resource code like "message"
	 * @param {object} resourceUpdate the updates to bring to the resource
	 * @param {function} onSuccess the function to call on success
	 */
	updateResourceConfiguration: (resource, resourceUpdate, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "PUT",
					url: `/api/v1/resourceConfig/${resource}`,
					data: {
						update: resourceUpdate
					},
					onSuccess,
					onFailure
				})
			);
		};
	},
	/**
	 * Perform an action on a resource
	 * @param {object} data the data to send to the backend
	 * @param {function} onSuccess the function to call on success
	 * @param {function} onFailure the function to call on failure
	 */
	performAction: (data, onSuccess, onFailure = () => {}) => {
		return dispatch => {
			dispatch(
				api({
					method: "POST",
					url: `/api/v1/resource/action/perform`,
					data,
					onSuccess: res => {
						onSuccess(res);
					},
					onFailure: err => {
						onFailure(err.response?.data?.error ?? err);
					}
				})
			);
		};
	}
};

export default actions;
